import type { PixelTrackingEndpoint } from '@core/tracking'

export const FEED_CREATE_EMBED_INSTANCE: PixelTrackingEndpoint = {
  url: '/trk/feed:create_embed_instance',
  consent: 'essential',
  isUserEngagement: false,
}
export const FEED_CREATE_FEED_IMPRESSION: PixelTrackingEndpoint = {
  url: '/trk/feed:create_feed_impression',
  consent: 'essential',
  isUserEngagement: false,
}
export const FEED_CREATE_THUMBNAIL_IMPRESSION: PixelTrackingEndpoint = {
  url: '/trk/feed:create_thumbnail_impression',
  consent: 'essential',
  isUserEngagement: false,
}
export const FEED_SCROLL_END_VIDEOS: PixelTrackingEndpoint = {
  url: '/trk/feed:scroll_end_videos',
  consent: 'essential',
  isUserEngagement: true,
}
export const FEED_SCROLL_VIDEOS: PixelTrackingEndpoint = {
  url: '/trk/feed:scroll_videos',
  consent: 'essential',
  isUserEngagement: true,
}
export const FEED_CLICK_VIDEO: PixelTrackingEndpoint = {
  url: '/trk/feed:click_video',
  consent: 'essential',
  isUserEngagement: false,
}
export const SELECT_TARGET_CALENDAR: PixelTrackingEndpoint = {
  url: '/trk/livestream:select_target_calendar',
  consent: 'essential',
  isUserEngagement: true,
}

export const FEED_CONTROL_GROUP_EMBED_INSTANCE: PixelTrackingEndpoint = {
  url: '/trk/feed:control_group_embed_instance',
  consent: 'essential',
  isUserEngagement: true,
}

export const FEED_CONTROL_GROUP_IMPRESSION: PixelTrackingEndpoint = {
  url: '/trk/feed:control_group_feed_impression',
  consent: 'essential',
  isUserEngagement: true,
}

/**
 * Diagnostics
 */

export const WIDGET_PARAMS_UPDATED: PixelTrackingEndpoint = {
  url: '/dx/widget:params_updated',
  isUserEngagement: false,
  consent: 'essential',
}
